import api from '@/api';

const { $student, $academic } = api;


export const { $students, $materias, $studentSubjects } = $student;
export const { $professionalPracticeTerms, $setting} = $academic;

